import classNames from 'classnames';

export type ButtonVariant = 'primary' | 'secondary' | 'danger';
export type ButtonSize = 'touch' | 'lg';

export interface ButtonClassNameOptions {
    variant?: ButtonVariant;
    size?: ButtonSize;
    block?: boolean;
}

const variantClasses: Record<ButtonVariant, string> = {
    primary: 'mp-btn--primary',
    secondary: 'mp-btn--secondary',
    danger: 'mp-btn--danger',
};

const sizeClasses: Record<ButtonSize, string> = {
    touch: 'mp-btn--touch',
    lg: 'mp-btn--lg',
};

export const buttonClassName = ({variant = 'primary', size = 'touch', block = false}: ButtonClassNameOptions = {}): string =>
    classNames('mp-btn', sizeClasses[size], variantClasses[variant], {'mp-btn--block': block});
